module.exports = __webpack_public_path__ + "static/Bild6-de87e5df7928a55c13591826890c8616.png";